import Authority from './Authority.vue'
import ApiBtn from './ApiBtn.vue'
import ApiIcon from './ApiIcon.vue'


const components = [
    Authority,
    ApiBtn,
    ApiIcon,
]

export default {
    install: (app) => {
        components.forEach(component => {
            app.component(component.name, component)
        })
    }
}